import { render, staticRenderFns } from "./new-summary-report.vue?vue&type=template&id=12bc1158"
import script from "./new-summary-report.vue?vue&type=script&lang=js"
export * from "./new-summary-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports